/* eslint-disable no-unused-vars */
import {
    Form,
    Alert,
    Space,
    Input,
    Button,
    Typography,
    FormInstance,
    Select,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { FC } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { TFunction, useTranslation } from 'react-i18next';
import { startLoadMarketingData, useAuthStore } from '../../store/auth.store';
import { Footer } from '../../components/Onboarding/Footer';
import { Header } from '../../components/Onboarding/Header';
import IMAGES from '../../const/images';
import { QUESTIONS } from '../../const/questions.constants';

interface IProps {
    t: TFunction;
}

interface IFormContainerProps extends IProps {
    form: FormInstance;
    error: string | null;
    loading: boolean;
    onSubmit: (values: any) => void;
}

const { Title } = Typography;

const FormContainer: FC<IFormContainerProps> = ({
    t,
    form,
    error,
    loading,
    onSubmit,
}) => {
    const pattern = /[0-9]+$/i;

    return (
        <Form
            form={form}
            onFinish={onSubmit}
            layout="vertical"
        >
            {
                error && (
                    <Alert
                        message={t(error)}
                        type="error"
                        style={{ marginBottom: 24 }}
                    />
                )
            }

            {

                QUESTIONS.map((question: any) => (
                    question.type === 0
                        ? (
                            <Form.Item
                                key={question.name}
                                name={question.name}
                                label={t(question.label)}
                                rules={[{ required: true, message: t('FIELD_REQUIRED') }]}
                                initialValue={question.options[0].value}
                            >
                                <Select>
                                    {
                                        question.options.map((option: any) => (
                                            <Select.Option
                                                key={option.value}
                                                value={option.value}
                                            >
                                                {t(option.label)}
                                            </Select.Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        ) : (
                            <Form.Item
                                key={question.name}
                                name={question.name}
                                label={t(question.label)}
                                rules={[
                                    {
                                        required: true,
                                        message: t('FIELD_REQUIRED'),
                                    },
                                    {
                                        pattern: new RegExp(pattern),
                                        message: t('INVALID_FIELD_NUMBER'),
                                    },
                                ]}
                            >
                                <Input
                                    type={question.inputType}
                                    placeholder={t(question.placeholder)}
                                    onKeyDown={(event) => {
                                        const re = /^[0-9\b]+$/;
                                        if (!re.test(event.key) && event.key !== 'Backspace') {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </Form.Item>
                        )
                ))
            }

            <Button
                block
                type="primary"
                htmlType="submit"
                loading={loading}
            >
                {t('CREATE_ACCOUNT.CONTINUE')}
            </Button>
        </Form>
    );
};

const AboutYouScreen = () => {
    const { t } = useTranslation('onboarding');

    const [form] = Form.useForm();

    const { loading, error } = useAuthStore(
        useShallow((state) => ({
            loading: state.loading,
            error: state.error,
        })),
    );

    const navigate = useNavigate();

    const onSubmit = async (values: any) => {
        await startLoadMarketingData(values);
        navigate('/onboarding/create-workspace');
    };

    return (
        <div
            style={{ backgroundImage: `url(${IMAGES.login.spirals})` }}
            className="public-layout"
        >
            <div className="public-layout__container">
                <div className="public-layout__container--form">
                    <Space direction="vertical" size={40}>
                        <Header />
                        <Title
                            level={2}
                            style={{
                                color: '#6C8EEF',
                                marginBottom: 0,
                                textAlign: 'center',
                            }}
                        >
                            {t('ABOUT_YOU')}
                        </Title>
                        <Space direction="vertical" size={24}>
                            <FormContainer
                                t={t}
                                form={form}
                                error={error}
                                loading={loading}
                                onSubmit={onSubmit}
                            />
                        </Space>
                        <Footer />
                    </Space>
                </div>
            </div>
        </div>
    );
};

export { AboutYouScreen };
